import { render, staticRenderFns } from "./CurriculumStudentViewNECMonthly.vue?vue&type=template&id=7481a44c&scoped=true&"
import script from "./CurriculumStudentViewNECMonthly.vue?vue&type=script&lang=ts&"
export * from "./CurriculumStudentViewNECMonthly.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumStudentViewNECMonthly.vue?vue&type=style&index=0&id=7481a44c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481a44c",
  null
  
)

export default component.exports